import { createContext } from 'react';
import { ISnackbarProps } from '.';

interface SnackbarContextType {
	snackbar: ISnackbarProps;
	setSnackbar: (newState: Partial<ISnackbarProps>) => void;
	closeSnackbar: () => void;
}

export const SnackbarContext = createContext<SnackbarContextType | null>(null);

SnackbarContext.displayName = 'SnackbarContext';
